module.exports = __webpack_public_path__ + "static/img/cat.7fab40bc.webp";